<template>
    <div class="grid grid-cols-12 pt-21 max-md:mt-2 md:pt-25 items-end">
        <div class="col-span-12 md:col-span-9">
            <h2 class="headline-maxi group-hover:text-green transition duration-200">{{data.title}}</h2>
            <p class="headline-maxi-serif group-hover:text-green transition duration-200">{{$dateFormat(data.dateFrom, data.dateTo)}}</p>
        </div>
        <div class="col-span-12 md:col-span-3 md:text-right" v-if="data.ticketLink">
            <a :href="data.ticketLink" target="_blank" class="inline-block">
                <ElementButton title="Køb billet" englishTitle="Buy ticket"/>
            </a>
        </div>
        <div class="col-span-12">
            <Media :data="data.media" class="w-full block mt-2"/>
        </div>
    </div>
</template>

<script setup>
const { $dateFormat } = useNuxtApp()

const props = defineProps({
    data: {
        type: Object,
        default: {
            title: 'Gademonstre',
            dateFrom: '06.07.24',
            dateTo: '11.07.24',
            ticketLink: null,
            media: {
                url: 'https://sydhavnteater:8890/assets/Screenshot-2024-07-01-at-14.12.29.jpg',
                width: 1232,
                height: 1232,
                mimeType: 'image/jpeg',
                title: 'Hero image'
            }
        }
    }
})
</script>